export const TransactionConfigurationPermissions = {
  ViewTransactionConfiguration :  {
    components: null ,  
    componentsId: null , 
    permissionsId: '974c4089-6378-4914-886e-08dc0129f7d6' , 
    permissionsName: 'View Transaction Configuration'  ,  
  }
};
